<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="primary">
      <ion-button [disabled]="visibleTiles?.length === 0" (click)="modalController.dismiss(null, 'button')"> {{ 'core.done' | translate }} </ion-button>
    </ion-buttons>

    <ion-title>{{ 'homescreen.settings.title' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item-group>
      <ion-reorder-group [disabled]="false" (ionItemReorder)="handleReorder($any($event))" #reorderGroup>
        @for (enabledHomescreenItem of visibleTiles; track $index) {
          <ion-item-sliding #slidingItem>
            <ion-item [button]="true" detailIcon="remove-circle-outline" [detail]="true" (click)="openAlert(enabledHomescreenItem.id, slidingItem)">
              @if (enabledHomescreenItem.titleKey) {
                <ion-label>{{ enabledHomescreenItem.titleKey | translate }}</ion-label>
              } @else {
                <ion-label>{{ enabledHomescreenItem.id + '.title' | translate }}</ion-label>
              }
              <ion-reorder slot="start"></ion-reorder>
            </ion-item>
            <ion-item-options side="end">
              <ion-item-option [disabled]="visibleTiles.length < 2" color="danger" [expandable]="true" (click)="removeItem(enabledHomescreenItem.id.toString(), slidingItem)">
                <ion-icon slot="icon-only" name="remove-circle-outline"></ion-icon>
              </ion-item-option>
            </ion-item-options>
          </ion-item-sliding>
        }
      </ion-reorder-group>
    </ion-item-group>
    @if (invisibleTiles?.length) {
      <ion-item-group>
        <ion-item-divider>
          <ion-label>Deaktivierte Kacheln</ion-label>
        </ion-item-divider>
        @for (inactiveHomescreenItem of invisibleTiles; track $index) {
          <ion-item-sliding>
            <ion-item [button]="true" detailIcon="add-circle-outline" [detail]="true" (click)="openAddAlert(inactiveHomescreenItem)">
              @if (inactiveHomescreenItem.titleKey) {
                <ion-label>{{ inactiveHomescreenItem.titleKey | translate }}</ion-label>
              } @else {
                <ion-label>{{ inactiveHomescreenItem.id + '.title' | translate }}</ion-label>
              }
            </ion-item>
            <ion-item-options side="start">
              <ion-item-option [expandable]="true" (click)="openAddAlert(inactiveHomescreenItem)">
                <ion-icon slot="icon-only" name="add-circle-outline"></ion-icon>
              </ion-item-option>
            </ion-item-options>
          </ion-item-sliding>
        }
      </ion-item-group>
    }
  </ion-list>
</ion-content>
